import { ChevronRight } from "@material-ui/icons";
import styled from "styled-components/macro";
import { InputSwitch, ButtonText } from "@loanbossinc/component-library";
import { IconButton } from "@material-ui/core";

export const Container = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Card = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
`;

export const StyledBodyWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 600px;
  }
`;

export const StyledReportWrapper = styled.div`
    align-items: center;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dadce0;
    box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25); 
    cursor: pointer;
    justify-content: space-between;
    width: 100%;
`;

export const Header = styled.div`
  && {
    align-items: center;
    color: #000000;
    display: flex;
    font-family: Work Sans;
    font-size: 22px;
    font-style: normal;
    font-weight: normal;
    line-height: 23px;
    text-align: center;
    margin-bottom: 1em;
  }
`;

export const ListItemIcon = styled.div`
  && {
    padding: 1em;
  }
`;

export const ListItemDeliveryPeriodWrapper = styled.div`
  && {
    display: flex;
    height: 30px;
    justify-content: flex-end;
    margin-bottom: 5px;
    margin-top: 15px;
  }
`;

export const ListItemIconWrapper = styled.div`
  && {
    display: flex;
    flex-direction: row;
    gap: 1em;
    justify-content: flex-end;
    margin-bottom: 5px;
    padding-right: 10px;
  }
`;

export const ListItemContent = styled.div`
  && {
    padding: 0px 5px;
    text-align: left;
  }
`;

export const ListItemFlexEndWrapper = styled.div`
  && {
    display: flex;
    justify-content: flex-end;
  }
`;

export const ListItemCalcWrapper = styled.div`
  && {
    height: 85px;
    padding-top: 10px;
  }
`;

export const ListItemTitle = styled.div`
  && {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #005AA9;
    padding-left: 10px;
  }
`;

export const ListItemSubTitle = styled.div`
  && {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    color: #000000;
    padding: 20px 10px 15px 10px;
  }
`;

export const ListItemText = styled.div`
  && {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: #5F6368;
    padding: 15px 10px 15px 10px;
  }
`;

export const ListItemDSCRSignifier = styled.div`
  && {
    background: #0F9AD6;
    border-radius: 4px;
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
    width: 64px;
    height: 24px;
    padding: 2px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ListItemDebtYieldSignifier = styled.div`
  && {
    background: #005AA9;
    border-radius: 4px;
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px; 
    text-align: center;
    color: #FFFFFF;
    width: 64px;
    height: 24px;
    padding: 2px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ListItemDeliveryDayBox = styled.div`
  && {
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #DADCE0;
    border-radius: 8px;
    width: 68px;
    height: 68px;
    margin-left: 12px;
  }
`;

export const ListItemDelivery = styled.div`
  && {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    color: #000000;
    padding-top: 8px;
  }
`;

export const ListItemDays = styled.div`
  && {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    text-align: center;
    color: #5F6368;
  }
`;

export const ListItemWrapper = styled.div`
  && {
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #dadce0;
    border-radius: 8px 8px 0px 0px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;

    &:last-child {
      border-radius: 0px 0px 8px 8px;
      border-bottom: 0px none #dadce0;
    }

    &:only-child {
      border-radius: 8px;
    }
  }
`;

export const StickyWrapper = styled.div`
  position: sticky !important;
  top: 20px !important;
`;

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9;
  }
`;

export const NewBadge = styled.div`
  && {
    background: #0f9ad6;
    border-radius: 4px;
    width: 46px;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    text-transform: uppercase;
    color: #fff;
    padding: 0.2em;
    margin-left: 1.5em;
    margin-right: 1.5em;
  }
`;

export const PriorReportsListItem = styled.button`
  && {
    width: 100%;
    border: 1px solid #dadce0;
    background: #fff;
    padding: 1em;
    margin-top: -1px;
    margin-bottom: 1px;
    text-align: left;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #005aa9;
    cursor: pointer;
  }
`;

export const ReportDetailsContentWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    margin: 1em;
  }
`;

export const HeaderIconRefreshWrapper = styled.div`
  && {
    display: flex;
    justify-content: space-between;
  }
`;

export const LabeledIconWrapper = styled.div`
  && {
    padding-top: 2em;
    padding-bottom: 1em;
  }
`;

export const StyledChevronRightHover = styled(ChevronRight)`
  && {
    color: #005aa9;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReportNameSection = styled.div`
  display: flex;
  min-height: 40px;
  padding-top: 0;
  padding-bottom: 23px;
  border-bottom: 1px solid #dadce0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

export const StyledDate = styled.div`
  color: ${props => props.color || "#5F6368"};
  font-size: ${props => props.size || "12px"};
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  line-height: 130%;
  padding: 3px 0;
  text-align: left;
  padding-top: 0.5em;
`;

export const ReportComponentWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #dadce0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  min-height: 70px;
`;

export const LabelLink = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #005aa9;

  &:hover {
    cursor: pointer;
  }
`;

export const ComponentInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 40px;
`;

export const StyledNeedsReview = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #c40a0a;
`;

export const ReportName = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;

export const StyledReportComponentHeaderWrapper = styled.div`
  && {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    flex-grow: 1;
    padding: 12px;
    box-sizing: border-box;
  }
`;

export const StyledHeaderStats = styled.div`
  margin-left: 12px;
  margin-right: 12px;
  align-self: center;
  width: 74px;
  height: 32px;
  background-color: #fafafa;
  border: 1px solid #dadce0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6368;
`;

export const StyledHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 12px;
  margin-right: 12px;
  align-self: center;
`;

export const NoReports = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
`;

export const StyledButtonText = styled(ButtonText)`
    & .MuiButton-label .material-icons {
      padding-left: 5px;
  }
`;

export const StyledHeaderLinks = styled.div`
  margin-left: 12px;
  align-self: center;
  display: flex;

  & button {
    width: 30px !important;
    height: 30px !important;
    padding: 8px;
  }
  & button:hover {
    background-color: initial !important;

    svg {
      color: #005aa9 !important;
    }
  }
`;

export const StyledReportComponentName = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 7px;
`;

export const StyledReportComponentDate = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  opacity: 0.5;
`;

export const StyledReportHeaderWrapper = styled.div`
  height: ${props => (props.isDraft ? "56px" : "84px")};
  width: 100%;
  background: #FAFAFA;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  padding: 24px;
  padding-bottom: 6px;
`;

export const StyledReportHeaderDates = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 24px;
  justify-content: space-evenly;
  max-width: 40%;
  max-height: 100%;
`;

export const StyledAsOfDate = styled.div`
  font-style: normal;
  font-family: Work Sans;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000;
`;

export const StyledDueDate = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #5F6368;
`;

export const StyledLockedSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

export const RefreshWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 60%;
  padding-right: 20px;
`;

export const StyledRefreshButton = styled(ButtonText)`
  height: 30px !important;
  padding-top: 24px;
  margin-left: -0.5em;
  .label {
    margin-left: 0.5em;
  }
  &:disabled {
    color: #c4c4c4 !important;
  }
`;

export const LockedIconStyle = styled.div`
  width: 32px;
  height: 32px;
  background: ${props => (props.isLocked ? "#ffffff" : "#005aa9")};
  border: 1px solid #005aa9;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 10px;

  svg {
    width: 18px;
    color: #005aa9;
  }

  i {
    font-size: 20px;
    width: 20px;
    height: 20px;
    color: #ffffff;
  }
`;

export const LogsContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LogsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LogsContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #ffffff;
  font-size: 13px;
  font-family: "Work Sans";
  margin-top: 1em;
  padding: 0.5em;
  border-radius: 10px;
  position: relative;
`;

export const LogsContentRow = styled.div`
  display: flex;
  width: 100%;
`;

export const LogsContentLeft = styled.div`
  display: flex;
  min-width: 27%;
`;
export const LogsContentRight = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 1em;
  font-size: 12px;
`;

export const StyledSectionHeader = styled.div`
  font-family: "Work Sans";
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #000;
  margin-bottom: 20px;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    width: 24px;
    height: 24px;
    color: #005AA9;
    &:disabled {
      color: #C4C4C4;
    }
  }
`;
